import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Visibility, VisibilityOff } from '@material-ui/icons';

const S = {
  Switch: styled.button`
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 62px;
    height: 32px;
    ::before {
      content: '';
      display: block;
      width: 50px;
      height: 20px;
      border-radius: 40px;
      background-color: ${({ active, theme }) => (active ? '#75e1c6' : theme.palette.grey[600])};
      box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.24), 0 0 1px 0 rgba(0, 0, 0, 0.12);
      transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    }
    outline: none;
  `,
  Thumb: styled.div`
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 50%;
    transform: ${({ active }) => `translate(${active ? 16 : -16}px, -50%)`};
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.palette.secondary.contrastText};
    box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.24), 0 0 1px 0 rgba(0, 0, 0, 0.12);
    transition: transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  `,
  Visibility: styled(Visibility)`
    color: ${({ theme }) => theme.palette.secondary.main};
    font-size: 1.25rem;
  `,
  VisibilityOff: styled(VisibilityOff)`
  color: ${({ theme }) => theme.palette.grey[900]};
    font-size: 1.25rem;
  `,
};

const VisibilitySwitcher = ({ onClick, ...otherProps }) => {
  const [active, setAcitve] = useState(true);

  const handleClick = useCallback(() => {
    onClick();

    setAcitve((prevActive) => !prevActive);
  }, [onClick]);
  return (
    <S.Switch {...otherProps} active={active} type="button" onClick={handleClick}>
      <S.Thumb active={active}>
        {active ? <S.Visibility /> : <S.VisibilityOff />}
      </S.Thumb>
    </S.Switch>
  );
};

VisibilitySwitcher.propTypes = {
  onClick: PropTypes.func,
};

VisibilitySwitcher.defaultProps = {
  onClick: () => {},
};

export default VisibilitySwitcher;
